











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CzSegments extends Vue {
  @Prop({ type: Number, default: 0 }) done!: number;
  @Prop({ type: Number, default: 1 }) total!: number;
  @Prop({ type: Boolean, default: false }) markCurrent!: boolean;
  @Prop({ type: String, default: "" }) label!: string;

  get states() {
    return Array.from({ length: this.total }, (_, index) => {
      if (index < this.done) return "done";
      if (this.markCurrent && index === this.done) return "current";
      return "todo";
    });
  }
}
